import React from 'react';

import {useGetAutoDeliveryDetails} from '@/api/consumerApi';
import {
    AUTO_DELIVERY_VIEW_ORDER_LINK,
    AUTO_DELIVERY_VIEW_ORDER_LINK_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import {PUSH_NOTIFICATIONS_PROMPT_TYPES} from '@/consts/pushNotifications/pushNotificationsPromptTypes';
import amplitudeAutodeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {schedulePushPromptIfNeeded} from '@/services/pushNotification/pushNotificationPromptService';
import AutoDeliveryActiveProgress from '@/views/AutoDelivery/AutoDeliveryActive/AutoDeliveryActiveProgress';
import AutoDeliveryOnHoldButton from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldButton';
import AutoDeliveryOnHoldInfoBox from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldInfoBox';
import AutoDeliveryOnHoldSubtitle from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldSubtitle';
import AutoDeliveryOnHoldTitle from '@/views/AutoDelivery/AutoDeliveryOnHold/AutoDeliveryOnHoldTitle';

import AutoDeliveryWidgetContainer from './components/AutoDeliveryWidgetContainer';
import AutoDeliveryWidgetHeader from './components/AutoDeliveryWidgetHeader';

const AutoDeliveryStatusOnHold = ({className}) => {
    const {
        data: {
            autoDelivery: {statusUpdateReason, status},
            order: {status: orderStatus},
        },
    } = useGetAutoDeliveryDetails();

    const amplitudeEvent = (trackingValue) => {
        schedulePushPromptIfNeeded(PUSH_NOTIFICATIONS_PROMPT_TYPES.AUTODELIVERY_DASHBOARD_CLICK);
        amplitudeAutodeliveryTracking.trackAutoDeliveryDashboardButtonClick(trackingValue);
        googleAnalyticsService.trackAutoDeliveryDashboardButtonClick(trackingValue);
    };

    return (
        <AutoDeliveryWidgetContainer className={className}>
            <AutoDeliveryWidgetHeader
                btnLocalizationKey={AUTO_DELIVERY_VIEW_ORDER_LINK}
                btnAriaLabelKey={AUTO_DELIVERY_VIEW_ORDER_LINK_ARIA_LABEL}
            />
            <AutoDeliveryWidgetContainer.ContentContainer>
                <AutoDeliveryOnHoldInfoBox statusUpdateReason={statusUpdateReason} className='mt-4 md:mt-0' />
                <AutoDeliveryOnHoldSubtitle statusUpdateReason={statusUpdateReason} className='mt-4 md:mt-8' />
                <AutoDeliveryOnHoldTitle className='md:mt-2' />
                <AutoDeliveryActiveProgress status={status} orderStatus={orderStatus} className='mt-4 md:mt-8' />
                <AutoDeliveryOnHoldButton
                    statusUpdateReason={statusUpdateReason}
                    amplitudeEvent={amplitudeEvent}
                    className='mt-4 md:w-auto'
                />
            </AutoDeliveryWidgetContainer.ContentContainer>
        </AutoDeliveryWidgetContainer>
    );
};

export default AutoDeliveryStatusOnHold;
